import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from '@/App.jsx'
import '@/i18n'

import * as Sentry from "@sentry/react";
import {ErrorScreen} from "@/components/ErrorScreen.jsx";

const isProd = import.meta.env.PROD;

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: true,
            blockAllMedia: false,
        }),
    ],

    tracesSampleRate: isProd ? 1.0 : 0,

    // 2. Replay (Vidéo) :
    replaysSessionSampleRate: 0, // 0 partout (RGPD : on ne filme pas les sessions normales)

    replaysOnErrorSampleRate: isProd ? 1.0 : 0,

    // Tag pour trier dans l'interface Sentry
    environment: import.meta.env.MODE,


    enabled: isProd,
});

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <Sentry.ErrorBoundary fallback={<ErrorScreen/>}>
            <App/>
        </Sentry.ErrorBoundary>
    </StrictMode>,
)